import { TemplateModel } from "../preview/models/template.model";

export const localImages = {
  smartAccountingLogo: "../../../assets/icons/co_logo2.svg",
  backIcon: "../../../assets/icons/back-icon.svg",
  userIcon: '../../../assets/icons/user.svg',
  invoicesIcon: '../../../assets/icons/invoices.svg',
  convertersIcon: '../../../assets/icons/converter.svg',
  sifrarnikIcon: '../../../assets/icons/sifrarnik.svg',
  addFolderIcon: '../../../assets/icons/add-folder-icon.svg',
  editIcon: '../../../assets/icons/edit-icon.svg',
  deleteIcon: '../../../assets/icons/delete-icon.svg',
  yesDeleteIcon: '../../../assets/icons/yes-delete-icon.svg',
  loginIcon: '../../../assets/icons/login-icon.svg',
  loginPasswordIcon: '../../../assets/icons/login-password-icon.svg',
  forgotPassword: '../../../assets/icons/forgot-password-icon.svg',
  doneIcon: '../../../assets/icons/done-icon.svg',
  downloadIcon: '../../../assets/icons/download-icon.svg',
  saveChangesIcon: '../../../assets/icons/save-changes-icon.svg',
  clientIcon: '../../../assets/icons/clients.svg',
  downloadScanIcon: '../../../assets/icons/download_icon.svg',
  downloadScanIconBlack: '../../../assets/icons/download_icon_black.svg',
  fileDocument: '../../../assets/icons/pdf-icon.svg',
  textFileDocument: '../../../assets/icons/txt-icon.svg',
  profileIcon: '../../../assets/icons/profile.svg',
  keyboardTab: '../../../assets/icons/keyboard_tab.svg',
  rotateRight: '../../../assets/icons/rotate-right.svg',
  fiWeIcon: '../../../assets/icons/fi-we-2-logo.png'
}

export const overviewStatistics = [
  {
    label: 'Scans',
    amount: 0
  }
]

export const overviewFilters: any[] = [{
  key: 'total',
  isButtonSelected: true
}]

export const stringsList = {
  welcomeHeading: 'Welcome to Company in Clouds',
  subheading: 'INVOICES DIGITALIZED',
  createFolder: 'Create a folder',
  logOut: 'Log out',
  saveChanges: 'Save changes',
  previewTemplate: 'Preview Template',
  scans: 'Scans',
  clients: 'Clients',
  newClient: 'New client',
  addAction: 'add',
  deleteAction: 'delete',
  addNewClient: 'Add new client',
  newTemplate: 'Add new template',
  createTemplate: 'Create a template',
  login: 'Log in',
  doAction: 'doAction',
  forgotPassword: 'Forgot password?',
  deleteTemplate: 'Delete template?',
  deleteClient: 'Delete?',
  deleteInvoice: 'Delete document?',
  invoiceContentPartOne: 'Are you sure you want to delete this document, you can\'t undo this action',
  invoiceContentPartTwo: 'You can’t undo this. Are you sure you want to proceed with this operation?',
  contentPartOne: 'You are about to delete template: ',
  contentPartTwo: 'You can’t undo this. Are you sure you want to delete this template?',
  clientDeletePartOne: 'You are about to delete client: ',
  clientDeletePartTwo: 'You can’t undo this. Are you sure you want to delete this client?',
  deleteDialogAction: 'Yes, delete',
  described: '- described',
  noDescription: '- no description',
  editFolder: 'Edit folder',
  deleteFolder: 'Delete folder?',
  folderContentPartOne: 'Are you sure you want to delete this folder: ',
  folderContentPartTwo: 'You can’t undo this action.',
  cantLoggIn: 'Can’t Log in?',
  enterYourEmail: 'Enter your e-mail and we’ll send you a verification code to get back into your account.',
  sendLoginLink: 'Send login link',
  newPassword: 'New Password',
  oneMoreStep: 'Just one more step. Please type in your new password.',
  changePassword: 'Change password'
}
export const navigationConstants = [
  {
    route: 'overview',
    icon: 'overviewIcon'
  },
  {
    route: 'invoices',
    icon: 'invoicesIcon'
  },
  {
    route: 'converter',
    icon: 'convertersIcon'
  },
  {
    route: 'codebook',
    icon: 'sifrarnikIcon'
  },
  {
    route: 'templates',
    icon: 'templatesIcon'
  },
  {
    route: 'fi-we',
    icon: 'fiWeIcon'
  },
  {
    route: 'profile',
    icon: 'profileIcon'
  }
]

export const folderStatuses = {
  INIT: 'INIT',
  IN_QUEUE: 'IN_QUEUE',
  IN_PROCESSING: 'IN_PROCESSING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  CANCELED: "CANCELED"
}

// export const templates: TemplateModel[] = [
//   {
//     id: '2895685639825689',
//     _name: 'Template no.1',
//     _description: 'The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero\'s De Finibus Bonorum et Malorum for use in a type specimen book.'
//   },
//   {
//     id: '862586548396435',
//     _name: 'Template no.2',
//     _description: ''
//   },
//   {
//     id: '68795765747942',
//     _name: 'Template no.3',
//     _description: ''
//   },
//   {
//     id: '76576545536436433',
//     _name: 'Template no.4',
//     _description: ''
//   },
//   {
//     id: '4354566643643',
//     _name: 'Template no.5',
//     _description: 'Parts of Cicero\'s De Finibus Bonorum et Malorum for use in a type specimen book'
//   },
//   {
//     id: '23579685866565',
//     _name: 'Template no.6',
//     _description: ''
//   }
// ]
